<div appPanel (closePanelEmitter)="dialogRef.close()"></div>

<div class="modal_content -large">
  <button class="mat-modal-closer" mat-dialog-close>
    <svg-icon
      src="assets/images/svg-icons/icon-times-light.svg"
      [svgStyle]="{ 'width.px': '18' }"
    ></svg-icon>
  </button>

  <div class="modal-inside bg-theme-white">
    <div class="modal-circles -noImage">
      <div class="background -green"></div>
      <div class="circle-1"></div>
      <div class="circle-2"></div>
    </div>

    <div class="modal-text">
      <div class="modal-picto -picto-svg -green">
        <svg-icon
          src="assets/images/svg-icons/icon-infos.svg"
          [svgStyle]="{ 'width.px': '30' }"
        ></svg-icon>
      </div>

      <div class="w-full mb-8">
        <div class="block-iframe">
          <iframe
            class="w-full"
            src="https://www.youtube.com/embed/zSw9n-PHC8g?si=EDVBLWEfKoHUTJVy"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>

      <div class="modal-title">EXPLICATIONS ECOS EDN</div>

      <div class="space-y-4">
        <p>
          Pour vous aider à préparer au mieux les ECOS, EDN vous accompagne en vous proposant une
          base de sujets, inspirés des situations de départ SIDES, qui sera complétée régulièrement.
          La modalité ECOS sur EDN permet de s’entraîner seul (parce qu’il n’y aura pas toujours
          quelqu’un disponible pour jouer l’acteur et l’évaluateur), avec un patient virtuel qui
          interagira avec vous. Le but étant surtout de vous apprendre à structurer vos idées et à
          ressortir des "mots clés", qui vous rapporteront des points le jour J !<br />
          Il y aura différents types de cas (comme pour les vrais ECOS). Des cas de "dialogue avec
          le patient", des cas plus "analytiques" d’examens paracliniques, des cas de communication
          interprofessionnelle … Nous essayons de créer du contenu le plus divers possible afin que
          vous soyez préparés à toutes les éventualités.
        </p>
        <p>Voici en quelques lignes le <strong>"mode d’emploi"</strong> des ECOS sur EDN.</p>
        <p>
          Lorsque vous choisirez un cas d’ECOS, la situation de départ (ou SSD) et le domaine
          d’apprentissage correspondant vous seront donnés. Vous aurez également un sujet comprenant
          des informations importantes sur votre patient, la raison de la consultation (plus ou
          moins détaillée) et la consigne (c’est-à-dire ce qu’on attend de vous pour ce cas). <br />
          Au niveau de la consigne vous verrez souvent précisé le mode que vous devrez utiliser pour
          répondre à chaque sous partie de la consigne ("poser une question", "examiner le patient"
          ou "réaliser un acte technique".
          <em>Voir ci-dessous pour l’explication de ce qu’est un mode</em>).
        </p>
        <p>
          Passons à la partie réalisation de l’ECOS. Comme il vous a été précisé plus haut, le but
          n’est pas réellement de discuter avec votre patient, mais d’utiliser des mots clés qui
          seront nécessaires pour gagner des points le jour des "vrais ECOS". Il faudra uniquement
          cibler les éléments pertinents pour avancer dans le cas (<em
            >par exemple ne pas demander un examen clinique complet, examen clinique cutané, examen
            clinique articulaire … pour une suspicion d’AVC. Un examen clinique neurologique,
            moteur, sensitif, ROT, cardiovasculaire à la recherche d’une arythmie ou d’athérome …
            sera bien plus pertinent et vous rapportera des points</em
          >). Il vous est également demandé d’être le plus précis possible dans vos réponses.
        </p>
        <p>
          Pour interagir avec le patient virtuel, vous devez choisir à chaque "interaction" un mode
          qui vous aura été précisé dans la consigne (<em
            >"poser une question", "examiner le patient" ou "réaliser un acte médical", d’autres
            modes apparaîtront prochainement</em
          >). Une fois le mode choisi vous devrez utiliser des mots clés (type QROC, et non des
          phrases, sinon vous n’obtiendrez pas les points) afin d’obtenir les informations que vous
          souhaitez ou pour répondre aux éléments qui vous auront été demandés dans la consigne.
          C’est à vous de juger quand vous avez donné ou recherché suffisamment d’informations pour
          passer à une autre "sous partie" de la consigne (comme pour les vrais ECOS).
        </p>
        <p>
          Voici un petit exemple pour vous illustrer tout ça ! <br />
          Imaginons que vous ayez un patient qui vient pour céphalées.
        </p>
        <p><strong>Vous aurez pour consigne : vous avez 7 minutes pour : </strong></p>
        <ul>
          <li>
            <strong class="text-site-main-one"
              >Explorer les symptômes du patient ("poser une question", "examiner le
              patient")</strong
            >
          </li>
          <li>
            <strong class="text-site-main-one"
              >Proposer une/des exploration(s) complémentaire(s) ("réaliser un acte
              technique")</strong
            >
          </li>
          <li>
            <strong class="text-site-main-one"
              >Poser un diagnostic et proposer un traitement ("poser une question")</strong
            >
          </li>
        </ul>
        <p>Voici comment se présentera l’interface :</p>
        <ul>
          <li>
            Pour commencer vous choisirez le mode "poser une question", pour interroger le patient
            sur ses symptômes. Dans la barre de recherche vous rentrerez des mots clés (type QROC)
            afin de rechercher les informations pertinentes qui vous feront avancer sur le cas. Par
            exemple "Température", "Mode d’installation", "intensité de la douleur" … Une réponse de
            l’acteur virtuel vous sera donnée en cas d’utilisation de mots clés pertinents.
          </li>

          <li>
            Puis vous choisirez le mode "examiner le patient" pour réaliser un examen clinique (
            <em>toujours en utilisant des mots clés</em>). Par exemple "raideur méningé" ou "examen
            de la nuque" ou "Kernig" ou "brudzinski" puis "examen neurologique » … Le résultat de
            chaque examen jugé pertinent vous sera donné à la suite de l’utilisation de ces mots
            clés.
          </li>

          <li>
            Une fois que vous jugez avoir suffisamment exploré les symptômes de votre patient vous
            pouvez commencer à répondre à la "sous partie" suivante de la consigne (proposer des
            explorations complémentaires). Vous utiliserez donc le mode "réaliser un acte technique"
            pour demander par exemple : "ponction lombaire", "glycémie", "CRP", "Scanner cérébral »
            … Les résultats de chaque examen jugé pertinent vous seront donnés à la suite de
            l’utilisation de ces mots clés.
          </li>

          <li>
            Puis en fonction des résultats, vous utiliserez le mode "poser une question" pour poser
            votre diagnostic : "méningite à méningocoque", "hémorragie méningée" … et proposer un
            traitement. Attention parfois il peut y avoir plusieurs diagnostics ou traitements, il
            faudra donc "interagir 2 fois" avec le patient. (Par exemple écrire "purpura fulminants"
            puis écrire "méningite à méningocoque"). Vous ne pouvez pas donner deux informations à
            la fois, sinon vous n’aurez pas les points...
          </li>
        </ul>
        <p>
          Une fois que vous pensez avoir fini de répondre à la consigne et si le temps n’est pas
          écoulé, vous pouvez finir la session vous-même (comme pour les DP EDN). Vous obtiendrez
          ensuite votre note, votre classement, une correction globale sur le cas et pour chaque
          élément de la grille un petit point de correction sera parfois ajouté.
        </p>

        <p>
          L’équipe EDN espère que le mode ECOS vous plaira !! Un petit temps d’adaptation vous sera
          peut-être nécessaire afin d’utiliser au mieux cette nouvelle modalité, donc ne vous
          affolez pas en cas de résultat non à la hauteur de vos attentes.
        </p>
        <p>
          <strong>Nous vous souhaitons de bonnes révisions et bonne chance pour vos ECOS !</strong>
        </p>
      </div>

      <div class="modal-buttons">
        <button
          matRipple
          [matRippleCentered]="false"
          [matRippleUnbounded]="true"
          [matRippleRadius]="50"
          type="button"
          class="btn-nnki btn-nnki-primary btn-nnki-uppercase"
          (click)="dialogRef.close()"
        >
          Fermer
        </button>
      </div>

      <div class="h-[60px] sm:hidden"></div>
    </div>
  </div>
</div>
